import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/${number | ':fieldReportId'}/fieldReportTypes/${number | ':fieldReportTypeId'}/preview`;

export const ROUTE: RouteDefinition = `${baseRoute}/:fieldReportId/fieldReportTypes/:fieldReportTypeId/preview`;

export const URL = (fieldReportId: number, fieldReportTypeId: number): RouteDefinition =>
	`${baseRoute}/${fieldReportId}/fieldReportTypes/${fieldReportTypeId}/preview`;
